import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Accordion from "@mui/material/Accordion";
import Fade from '@mui/material/Fade';
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import AddIcon from "@mui/icons-material/Add";
import { Grid } from "@mui/material";
import { SherbetLogo } from "../../../styles/images/svg/SherbetLogo";
import { NotificationTrueIcon } from "../../../styles/images/svg/notificationIcons";
import profile from "../../../styles/images/png/profile.png";
import LogoutIcon from "../../../styles/images/png/LogoutButton.png";
import Box from "@mui/material/Box";
import Badge from "@mui/material/Badge";
import {
     authGetUserDetailsRequest,
     dashBoardDeleteNotificationRequest,
     dashBoardGetNotificationRequest,
     logoutAuthRequest,
} from "../../../_redux/_actions";
import { createHubConnection } from "../../../../react/_helpers/support.services";
import {
     NotificationActive,
     NotificationIcon,
     CloseBlackIcon,
     DeleteIcon,
} from "../../../styles/images/svg/notificationIcons";
import { Context } from "../../../_context/Store";
import { contextApiActions } from "../../../_redux/_constants";
import { useSelector } from "react-redux";
import SherbetMainLogo from "../../../styles/images/sherbet-main-logo.png"

export const TopNavBar = (props) => {
     const [isPopupOpen, setIsPopupOpen] = useState(false);
     const [notifcationId, setNotificationId] = useState();

     const navigate = useNavigate();
     const actionDispatch = useDispatch();

     const [state, dispatch] = useContext(Context);

     const { auth, notification } = useSelector((state) => {
          return {
               auth: state.auth.userDetails,
               notification: state.dashboard.notification
          };
     });

     const handleClose = () => {
          setIsPopupOpen(!isPopupOpen);
     };

     const handleNotificationClick = () => {
          setIsPopupOpen(!isPopupOpen);
     };

     const handleContent = () => { };

     const [expanded, setExpanded] = React.useState(false);
     const [accordianExpand, setAccordianExpand] = useState(false)

     const handleChange = (panel) => (event, isExpanded) => {
          setAccordianExpand(isExpanded)
          setExpanded(isExpanded ? panel : false);
          setNotificationId(panel);
     };

     useEffect(() => {
          actionDispatch(authGetUserDetailsRequest());
         // actionDispatch(dashBoardGetNotificationRequest());
     }, []);


     useEffect(() => {
          let connection = null;

          if (typeof auth?.userId != "undefined") {
               connection = createHubConnection(auth?.userId);
               connection
                    .start()
                    .then(() => {
                         console.log("Connection established.");
                         dispatch({
                              type: contextApiActions.SET_SIGNALR_CONNECTTION,
                              payload: connection,
                         });
                    })
                    .catch((err) => console.log(err));
          }

          return () => {
               if (connection) {
                    connection.stop();
               }
          };
     }, [auth]);
     const logOut = (event) => {
          actionDispatch(logoutAuthRequest({ navigate }));
          event.stopPropagation();
     };

     return (
          <div className="sbt-topnav-wr">
               <div className="sbt-topnav-wr__left">
                    {/* <SherbetLogo /> */}
                    <img src={SherbetMainLogo} />
               </div>
               <div className="sbt-topnav-wr__right">
                    <div className="sbt-topnav-wr__right_notification">
                         {props.newNotification ? (
                              <Badge
                                   badgeContent={notification.length}
                                   color="error"
                                   className="sba-notification-badge"
                              >
                                   <span onClick={handleNotificationClick}>
                                        <NotificationActive color="action" />
                                   </span>

                                   {isPopupOpen && (
                                        <Box
                                             width={480}
                                             my={4}
                                             alignItems="center"
                                             gap={4}
                                             p={2}
                                             sx={{
                                                  border: "1px solid #ececec",
                                                  position: "absolute",
                                                  backgroundColor: "#ffffff",
                                                  zIndex: "10",
                                                  right: "0",
                                                  marginTop: "48px",
                                                  transition: "top 0.2s linear"
                                                  // maxHeight: "300px",
                                                  // overflowY: "auto",
                                             }}
                                        >


                                             <div className="sba-accordion-header">
                                                  <h4>My Notifications </h4>
                                                  <span onClick={handleClose}>
                                                       <CloseBlackIcon />
                                                  </span>
                                             </div>
                                             <div className="sba-notification-accordian-content-wr">
                                                  {notification.map((row) => (

                                                       <div className="sba-notification-accordion">
                                                            <Grid className="sba-notification-accordion-content">
                                                                 <Accordion
                                                                      className="sba-filter-accor"
                                                                      expanded={
                                                                           expanded === row?.id
                                                                      }
                                                                      onChange={handleChange(
                                                                           row?.id,
                                                                      )}
                                                                 >
                                                                      <AccordionSummary
                                                                           expandIcon={
                                                                                <AddIcon
                                                                                     onClick={
                                                                                          handleContent
                                                                                     }
                                                                                />
                                                                           }
                                                                           aria-controls="panel"
                                                                           id="panel1bh-header"
                                                                           className="sba-accordian-date"
                                                                      >
                                                                           <div className="sba-heading-top-wr">
                                                                                <div className="sba-heading-notification-date">
                                                                                     <span>{row?.displayDate}</span>
                                                                                </div>
                                                                                <div className="sba-notification-heading-wr">
                                                                                     <h5>{row?.title}</h5>
                                                                                     <span>{notifcationId !== row.id || notifcationId == row.id && !accordianExpand ? row?.body.substring(
                                                                                          0,
                                                                                          50,
                                                                                     ) : ''}</span>
                                                                                </div>
                                                                           </div>
                                                                      </AccordionSummary>
                                                                      <div className="sba-accordian-box">
                                                                           <AccordionDetails>
                                                                                <div className="sba-notification-acc">
                                                                                     <div className="sba-notification-expand-text"></div>
                                                                                     <div className="sba-notification-left-wr-content">
                                                                                          <p>{row?.body}</p>
                                                                                          <div className="sba-notification-delete-icon"
                                                                                               onClick={() => {
                                                                                                    actionDispatch(dashBoardDeleteNotificationRequest({
                                                                                                         id: row?.id,
                                                                                                         handleClose
                                                                                                    }))
                                                                                               }}>
                                                                                               <DeleteIcon />
                                                                                          </div>
                                                                                     </div>
                                                                                </div>
                                                                           </AccordionDetails>
                                                                      </div>
                                                                 </Accordion>
                                                            </Grid>
                                                       </div>

                                                  ))}
                                             </div>

                                        </Box>
                                   )}
                              </Badge>
                         ) : (
                              <NotificationIcon />
                         )}
                    </div>
                    <div className="sbt-topnav-wr__right_profile">
                         <img
                              src={
                                   auth?.profilePictureUrl
                                        ? auth?.profilePictureUrl
                                        : profile
                              }
                         />
                         <h2>
                              {auth?.firstName}
                              <br />
                              <span>{auth?.lastName}</span>
                         </h2>
                    </div>
                    <div
                         onClick={logOut}
                         className="sbt-topnav-wr__right__logout"
                    >
                         <img src={LogoutIcon} />
                    </div>
               </div>
          </div>
     );
};
